var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"myIcon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16","viewBox":"-1 -1 18 18","fill":"none"}},[_c('rect',{attrs:{"x":"0.5","y":"0.5","width":"15","height":"15","rx":"4","fill":"none"}})])}
var staticRenderFns = []

export { render, staticRenderFns }